function formateaFechaMMAAAA(fecha) {
  const mes = fecha.getMonth() + 1;
  const año = fecha.getFullYear();
  return `${mes}-${año}`;
}

export { formateaFechaMMAAAA };
